import * as React from "react";
import type { SVGProps } from "react";
const SvgMediumIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#medium_icon_svg__a)">
      <path
        fill="currentColor"
        d="M13.538 11.815c0 3.764-3.031 6.816-6.77 6.816C3.032 18.63 0 15.579 0 11.815S3.03 5 6.769 5c3.738 0 6.769 3.051 6.769 6.815Zm7.428.002c0 3.543-1.515 6.416-3.384 6.416-1.87 0-3.385-2.873-3.385-6.416S15.712 5.4 17.581 5.4c1.87 0 3.385 2.872 3.385 6.416Zm1.845 5.752c.658 0 1.19-2.575 1.19-5.748 0-3.175-.533-5.748-1.19-5.748-.657 0-1.19 2.574-1.19 5.748 0 3.174.533 5.748 1.19 5.748Z"
      />
    </g>
    <defs>
      <clipPath id="medium_icon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMediumIcon;
